import React, { FC } from 'react';
import { CustomSelect } from '../../commons/CustomSelect';
import { IMultiAccount } from '../../../models/UserInfo';

interface AccountAddressSelectProps {
  subAccount: number;
  optionsList: IMultiAccount[];
  handleSubAccountSelect: (id: number) => void;
}

export const AccountAddressSelect: FC<AccountAddressSelectProps> = ({
  subAccount,
  optionsList,
  handleSubAccountSelect,
}) => {
  const verifiedList = optionsList.filter((el) => el.Status === 'verified');

  const selectOptions = [
    ...verifiedList.map((el) => {
      return { id: el.UserID, label: el.User?.Address ?? '' };
    }),
  ];

  return (
    <CustomSelect
      value={subAccount}
      items={selectOptions}
      setValue={(e) => handleSubAccountSelect(e.target.value as number)}
      hasSearch
    />
  );
};
